<ts-dialog title="Bulk Task Update" (closeDialog)="dialogRef.close(false)">
  <div ts-dialog-body>
    <form class="flex flex-col justify-center gap-2" [formGroup]="bulkTaskForm">
      <span class="flex flex-row items-center justify-between">
        <p>Status</p>
        <ts-select
          itemKey="key"
          itemLabel="label"
          formControlName="workflow_state"
          class="w-1/2"
          [hasGroups]="false"
          [uiOptions]="{
            roundedBorders: false,
            placeholder: 'Status',
            searchPlaceholder: 'Task status...',
            size: 'full',
          }"
          [items]="workflowStates"
        ></ts-select>
      </span>

      <span class="flex flex-row items-center justify-between">
        <p>Assigned User</p>
        @if (users) {
          <ts-select
            itemKey="key"
            itemLabel="label"
            formControlName="assigned_user_id"
            class="w-1/2"
            [hasGroups]="false"
            [uiOptions]="{
              roundedBorders: false,
              placeholder: 'Select a user',
              searchPlaceholder: 'User name...',
              size: 'full',
            }"
            [items]="users"
          ></ts-select>
        }
      </span>

      <span class="flex flex-row items-center justify-between">
        <p>Followers</p>
        @if (users) {
          <ts-select
            itemKey="key"
            itemLabel="label"
            formControlName="following_user_ids"
            class="w-1/2"
            multi="true"
            [hasGroups]="false"
            [uiOptions]="{
              roundedBorders: false,
              placeholder: 'Select a user',
              searchPlaceholder: 'User name...',
              size: 'full',
            }"
            [items]="users"
          ></ts-select>
        }
      </span>
    </form>
  </div>

  <div class="ts-dialog-actions-container" ts-dialog-actions>
    <ts-button variant="secondary" (click)="dialogRef.close(false)" [disabled]="disabled">Cancel</ts-button>
    <ts-button variant="primary" (click)="updateTasks()" [disabled]="disabled">Update </ts-button>
  </div>
</ts-dialog>
